import React from 'react';
import Dotdotdot from 'react-dotdotdot';
import SportLabel from '../CardComponents/SportLabel';

const EventTemplateCard = (props) => {
    const {
        template,
        showSortScore,
        showTags,
        children,
        showSportLabel,
        'data-testid': dataTestId,
    } = props;
    const {
        name,
        description,
        order,
        verified,
        published,
        sportTypeId,
    } = template;

    const getTag = (block, tagPrefix) => {
        if (!published) {
            return <span className={`tag tag-gray tag-xs ${block ? 'tag-block' : ''}`} data-testid={tagPrefix && `${tagPrefix}.status-tag`}>Draft</span>;
        }

        return <span />;
    };

    return (
        <div className={`utr-card event-template-card ${showTags ? 'with-tags' : ''}`} data-testid={dataTestId || undefined}>
            {showSportLabel && <SportLabel sportTypeId={sportTypeId} data-testid={dataTestId && `${dataTestId}.sport-label`} />}
            {showTags && (
                <div className={`d-flex justify-content-end div8`}>
                    {getTag(false, dataTestId)}
                </div>
            )}
            <div className={`d-flex`}>
                <div className="flex-grow name ellipsis" data-testid={dataTestId && `${dataTestId}.name`}>{name}</div>
                {verified && (
                    <i className={`utr utr-sanctioned text-teal mt8`} title="Sanctioned" />
                )}
            </div>
            <div className="description" data-testid={dataTestId && `${dataTestId}.description`}>
                <Dotdotdot clamp={4}>
                    {description}
                </Dotdotdot>
            </div>
            <div className="div mb8" />
            <div className={`d-flex`}>
                <div className="flex-grow bottom-wrapper">
                    {children}
                </div>
                {showSortScore && (
                    <div className="fs11 text-medium mt8" data-testid={dataTestId && `${dataTestId}.sort-score`}>
                        Score: {order}
                    </div>
                )}
            </div>
        </div>
    );
};

EventTemplateCard.defaultProps = {
    'data-testid': null,
};

export default EventTemplateCard;
